import { UserRoleEnum } from 'entities/index';
export function roleTranslator(role: UserRoleEnum | undefined): string {
  switch (role) {
    case UserRoleEnum.OWNER:
      return 'Директор';
    case UserRoleEnum.ADMINISTRATOR:
      return 'Управляющий';
    case UserRoleEnum.MANAGER:
      return 'Менеджер';
    case UserRoleEnum.EMPLOYEE:
      return 'Сотрудник';
    default:
      return 'Пользователь';
  }
}
